import InstallerPayment from "./pages/Installer/InstallerPayment";
import React, { useEffect } from "react";
import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import { initializeApiClient } from "../src/api/apiClient";
import InstallerSetting from "./pages/Installer/InstallerSetting";
import InstallerJob from "./pages/Installer/InstallerJob";
import InstallerRequest from "./pages/Installer/InstallerRequest";
import InstallerAccount from "./pages/Installer/InstallerAccount";
import Signin from "./components/Signin";
import Layout from "./components/Layout";
import PhotographerAccount from "./pages/Photographer/PhotographerAccount";
import PhotographerRequest from "./pages/Photographer/PhotographerRequest";
import Photographerjob from "./pages/Photographer/Photographerjob";
import PhotographerPayment from "./pages/Photographer/PhotographerPayment";
import PhotographerSetting from "./pages/Photographer/PhotographerSetting";
import InstallerJobview from "./pages/Installer/InstallerJobview";
import PhotographerJobview from "./pages/Photographer/PhotographerJobview";
import AdvertisersAccount from "./pages/Advertiser/AdvertisersAccount";
import AdvertisersComping from "./pages/Advertiser/AdvertisersComping";
import AdvertisersCorporateAccount from "./pages/Advertiser/AdvertisersCorporateAccount";
import AdvertisersInvoice from "./pages/Advertiser/AdvertisersInvoice";
import { AdvertisersSetting } from "./pages/Advertiser/AdvertisersSetting";
import VehicleOwnersAccount from "./pages/Vehicleowners/VehicleOwnersAccount";
import VehicleOwnersVehicle from "./pages/Vehicleowners/VehicleOwnersVehicle";
import { VehicleOwnersAddVehicle } from "./pages/Vehicleowners/VehicleOwnersAddVehicle";
import VehicleOwnerPayment from "./pages/Vehicleowners/VehicleOwnerPayment";
import VehicleOwnerCompaing from "./pages/Vehicleowners/VehicleOwnerCompaing";
import VehicleOwnerCompaingView from "./pages/Vehicleowners/VehicleOwnerCompaingView";
import VehicleOwnerSettings from "./pages/Vehicleowners/VehicleOwnerSettings";
import VehicleOwnersWelcome from "./pages/Vehicleowners/VehicleOwnersWelcome";
import DriverIndex from "./pages/Driver/DriverIndex";
import DriverSearchResult from "./pages/Driver/DriverSearchResult";
import RequestCompaing from "./pages/Driver/RequestCompaing";
import SubmitRequest from "./pages/Driver/SubmitRequest";
import ScheduleEvent from "./pages/Driver/ScheduleEvent";
import InstallerSchedule from "./pages/Installer/InstallerSchedule";
import Chat from "./components/Chat";
import PhotographerSchedule from "./pages/Photographer/PhotographerSchedule";
import VehicleOwnerSchedule from "./pages/Vehicleowners/VehicleOwnerSchedule";
import AdvertiserSchedule from "./pages/Advertiser/AdvertiserSchedule";
import VehicleOwnerRequest from "./pages/Vehicleowners/VehicleOwnerRequest";
import AdvertiserDonutEthnicities from "./pages/Advertiser/AdvertiserDonutEthnicities";
import AdvertiserDonutIncomeLevel from "./pages/Advertiser/AdvertiserDonutIncomeLevel";
import AdvertiserBarImpression from "./pages/Advertiser/AdvertiserBarImpression";
import AdvertiserBarBehavioral from "./pages/Advertiser/AdvertiserBarBehavioral";
import AdvertiserBarMiles from "./pages/Advertiser/AdvertiserBarMiles";
import Home from "./components/Home";
import AgencyPackages from "./components/AgencyPackages";
import SignupPopup from "./components/SignupPopup";
import VehicleOwnerNewCompaing from "./pages/Vehicleowners/VehicleOwnerNewCompaing";
import VehicleOwnerLiveMonitor from "./pages/Vehicleowners/VehicleOwnerLiveMonitor";
import DesignerAccount from "./pages/Designer/DesignerAccount";
import DesignerRequest from "./pages/Designer/DesignerRequest";
import DesignerSchedule from "./pages/Designer/DesignerSchedule";
import DesignerSetting from "./pages/Designer/DesignerSetting";
import DesignerJob from "./pages/Designer/DesignerJob";
import DesignerJobView from "./pages/Designer/DesignerJobview";
import DesignerPayment from "./pages/Designer/DesignerPayment";
import DashboardLayout from "./components/sidenav/DashboardLayout";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import {
  Campaigns,
  CampaignDetail,
  Requests,
  Payments,
  Miles,
  Users,
  UserDetail,
  AddUser,
  PaymentDetail,
} from "./pages/admin/";
import Jobs from "./pages/admin/Jobs";
import Arts from "./pages/admin/Arts";
import Product from "./pages/admin/Product";
import AddProductForm from "./components/AddProductForm";
import Vehicles from "./pages/admin/Vehicles";
import AddRequest from "./pages/admin/AddRequest";
import AddTeam from "./pages/admin/AddTeam";
import WaitingPage from "./pages/Waiting-Page";

import { AmainLocation } from "./pages/admin/AmainLocation";
import Forgetpasword from "./components/sidenav/Forgetpasword";
import { Restpassword } from "./pages/Vehicleowners/Restpassword";
import FindAccount from "./components/sidenav/FindAccount";

function App() {
  useEffect(() => {
    initializeApiClient();
  }, []);

  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        <Route index element={<Home />} />

        <Route path="/signUpPopup" element={<SignupPopup />} />
        <Route path="/waiting-page" element={<WaitingPage />} />
        {/* <Route path='/test' element={<Test/>}/> */}
        <Route path="/signin" element={<Signin />} />
        <Route path="/forgot-password" element={<FindAccount />} />
        <Route
          path="/password-reset/confirm/:id/:token"
          element={<Forgetpasword />}
        />
        <Route path="/resetpassword" element={<Restpassword />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/" element={<Layout user={1} />}>
          <Route path="/installeraccount" element={<InstallerAccount />} />
          <Route path="/installerrequest" element={<InstallerRequest />} />
          <Route path="/installer-schedule" element={<InstallerSchedule />} />
          <Route path="/installerjob" element={<InstallerJob />} />
          <Route path="/installerjob/new" element={<InstallerJobview />} />
          <Route path="/installerpayment" element={<InstallerPayment />} />
          <Route path="/installersetting" element={<InstallerSetting />} />
        </Route>

        <Route path="" element={<Layout user={2} />}>
          <Route path="/photograperaccount" element={<PhotographerAccount />} />
          <Route
            path="/photographerrequest"
            element={<PhotographerRequest />}
          />
          <Route
            path="/photographer-schedule"
            element={<PhotographerSchedule />}
          />
          <Route path="/photographerjob" element={<Photographerjob />} />
          <Route
            path="/photographerpayment"
            element={<PhotographerPayment />}
          />
          <Route
            path="/photographersetting"
            element={<PhotographerSetting />}
          />
          <Route
            path="/photographerjob/detail"
            element={<PhotographerJobview />}
          />
        </Route>

        <Route path="" element={<Layout user={3} />}>
          <Route path="/advertiser-account" element={<AdvertisersAccount />} />
          <Route path="/advertiser-campaign" element={<AdvertisersComping />} />
          <Route path="/advertiser-schedule" element={<AdvertiserSchedule />} />
          <Route
            path="/advertiserViewCampaign"
            element={<AdvertisersCorporateAccount />}
          />
          <Route path="/advertiser-invoice" element={<AdvertisersInvoice />} />
          <Route path="/advertiser-setting" element={<AdvertisersSetting />} />
          <Route
            path="/advertiserDounetEth"
            element={<AdvertiserDonutEthnicities />}
          />
          <Route
            path="/advertiserDounetIncom"
            element={<AdvertiserDonutIncomeLevel />}
          />
          <Route
            path="/advertiserBarImpression"
            element={<AdvertiserBarImpression />}
          />
          <Route
            path="/advertiserBarBehavioral"
            element={<AdvertiserBarBehavioral />}
          />
          <Route path="/advertiserBarMile" element={<AdvertiserBarMiles />} />
        </Route>

        <Route path="" element={<Layout user={4} />}>
          <Route
            path="/vehicleowneraccount"
            element={<VehicleOwnersAccount />}
          />
          <Route
            path="/vehicleownervehicle"
            element={<VehicleOwnersVehicle />}
          />
          <Route
            path="/vehicleowneraddvehicle"
            element={<VehicleOwnersAddVehicle />}
          />
          <Route
            path="/vehicleownerpayment"
            element={<VehicleOwnerPayment />}
          />
          <Route
            path="/vehicle-owner-schedule"
            element={<VehicleOwnerSchedule />}
          />
          <Route
            path="/vehicleownercampaigns"
            element={<VehicleOwnerCompaing />}
          />
          <Route
            path="/vehicleownercampaigns/new"
            element={<VehicleOwnerNewCompaing />}
          />
          <Route
            path="/vehicleownercampaigns/detail"
            element={<VehicleOwnerCompaingView />}
          />
          <Route
            path="/vehicleowner-live-monitor"
            element={<VehicleOwnerLiveMonitor />}
          />
          <Route
            path="/vehicleowner-request"
            element={<VehicleOwnerRequest />}
          />
          <Route
            path="/vehicleownersetting"
            element={<VehicleOwnerSettings />}
          />
          <Route
            path="/vehicleownerwelcome"
            element={<VehicleOwnersWelcome />}
          />
        </Route>

        <Route path="/" element={<Layout user={5} />}>
          <Route path="/designeraccount" element={<DesignerAccount />} />
          <Route
            path="/designer-live-monitor"
            element={<VehicleOwnerLiveMonitor />}
          />
          <Route path="/designerrequest" element={<DesignerRequest />} />
          <Route path="/designer-schedule" element={<DesignerSchedule />} />
          <Route path="/designerjob" element={<DesignerJob />} />
          <Route path="/designerjobview" element={<DesignerJobView />} />
          <Route path="/designerpayment" element={<DesignerPayment />} />
          <Route path="/designersetting" element={<DesignerSetting />} />
        </Route>

        <Route>
          {/* <Route path='/driver-search-result' element={<DriverIndex />}/> */}
          {/* <Route path='/driver-search-result' element={<DriverSearchResult  user={5}/>}/> */}
          <Route path="/agency-packages" element={<AgencyPackages />} />
          <Route path="/submit-request" element={<SubmitRequest />} />

          {/* <Route path='/request-comapaign' element={<RequestCompaing/>}/> */}
          <Route path="/schedule-event" element={<ScheduleEvent />} />
        </Route>
        <Route path="/" element={<DashboardLayout />}>
          <Route path="/admin/campaigns" element={<Campaigns />}></Route>
          <Route
            path="/admin/live-campaigns"
            element={<VehicleOwnerLiveMonitor />}
          />

          <Route path="/admin/campaigns/detail" element={<CampaignDetail />} />
          <Route path="/admin/jobs" element={<Jobs />} />
          <Route path="/admin/adminLocation" element={<AmainLocation />} />
          <Route path="/admin/arts" element={<Arts />} />
          <Route path="/admin/request" element={<Requests />} />
          <Route path="/admin/add-request" element={<AddRequest />} />
          <Route path="/admin/payments" element={<Payments />} />
          <Route path="/admin/payment/detail" element={<PaymentDetail />} />
          <Route path="/admin/mile" element={<Miles />} />
          <Route path="/admin/users" element={<Users role={"Team"} />} />
          <Route
            path="/admin/vendor/driver"
            element={<Users role={"Driver"} />}
          />
          <Route
            path="/admin/vendor/installer"
            element={<Users role={"Installer"} />}
          />
          <Route
            path="/admin/vendor/photographer"
            element={<Users role={"Photographer"} />}
          />
          <Route
            path="/admin/advertiser/corporation"
            element={<Users role={"Corporation"} />}
          />
          <Route
            path="/admin/advertiser/advertiser"
            element={<Users role={"Advertiser"} />}
          />
          <Route path="/admin/user/*" element={<UserDetail />} />
          <Route path="/admin/add-user" element={<AddUser />} />
          <Route path="/admin/add-team" element={<AddTeam />} />
          <Route path="/admin/product" element={<Product />} />
          <Route path="/admin/vehicles" element={<Vehicles />} />
          <Route path="/admin/add-product" element={<AddProductForm />} />

          {/* <Route
            path="/admin/*"
            element={<Navigate replace to={"/admin/campaigns"} />}
          /> */}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
